// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3goz8","content":"styles_content__xpcA6","row":"styles_row__2nAqW","footer":"styles_footer__2dkzF","phraseLength":"styles_phraseLength__172GN"};